
import {post} from '@/utils/request';
import {smcanteenserver,erpplatserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//菜品列表
export async function getList(params) {
    return post(smcanteenserver+'/foodInfo/getList', params, true)
}

//菜品保存
export async function save(params) {
    return post(smcanteenserver+'/foodInfo/save', params, true)
}

//菜品删除
export async function remove(params) {
    return post(smcanteenserver+'/foodInfo/delete', params, true)
}

//菜品详情
export async function getDetail(params) {
    return post(smcanteenserver+'/foodInfo/getDetail', params, true)
}

//上传图片
export async function upload(params) {
    return post(smcanteenserver+'/system/uploadFile',params,false);
}

//菜品类型下拉
export async function getDataDict(params) {
    return post(smcanteenserver+'/foodInfo/getDataDict',params,true);
}
